import React from 'react';

import { MultiSelect, MultiSelectProps } from '@mantine/core';
import { AthleteStatus } from 'types';

interface AthleteStatusMultiSelectProps extends Omit<MultiSelectProps, 'data'> {
  customOptions?: AthleteStatus['status'][];
}

const AthleteStatusMultiSelect = ({
  customOptions,
  ...multiSelectProps
}: AthleteStatusMultiSelectProps): JSX.Element => {
  const defaultOptions: AthleteStatus['status'][] = [
    'Prospect',
    'Visitor',
    'Trial',
    'Non-Paying Member',
    'Member',
    'Alumni',
  ];

  const options = customOptions || defaultOptions;

  return <MultiSelect data={options} {...multiSelectProps} />;
};

export default AthleteStatusMultiSelect;
